import axios from 'axios';
import { handleError } from '../utils/common';

export default class AuthService {
  afterLogin(data) {
    window.location =
      (process.env.REACT_APP_SUB_PATH ?? '/') + 'signup?id=' + data.otp_id;
  }

  login(username) {
    let data = { identifier: username };
    axios
      .post(process.env.REACT_APP_SOURCE_URL + '/api/user/login/send-otp', data)
      .then(response => this.afterLogin(response.data))
      .catch(error => {
        handleError(error);
      });
  }

  afterVerification(data) {
    console.log(data);
    console.log(data.access_token.user);
    localStorage.setItem('token', data.access_token.key);
    localStorage.setItem('profile', JSON.stringify(data.access_token.user));
    // localStorage.setItem('username', data.access_token.user.username);
    // localStorage.setItem('full_name', data.access_token.user.full_name);
    // localStorage.setItem('avatar', data.access_token.user.photo ? data.access_token.user.photo.url : default_image_path());
    window.location = process.env.REACT_APP_SUB_PATH ?? '/';
  }

  verify(pk, code) {
    let data = { pk: pk, code: code };
    axios
      .post(
        process.env.REACT_APP_SOURCE_URL + '/api/user/login-backoffice',
        data,
      )
      .then(response => this.afterVerification(response.data))
      .catch(error => {
        handleError(error);
      });
  }
}
